export enum ClaimType {
    ReportClaim,
    Reimbursement,
}
